"use client";

import { c as _c } from "react/compiler-runtime";
import styles from "./AppWallet.module.scss";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useRef, useState } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { faCheckCircle, faCircleArrowLeft, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ethers } from "ethers";
import { CreateAppWalletModal } from "./AppWalletModal";
import { useAuth } from "../auth/Auth";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import { useAppWallets } from "./AppWalletsContext";
import AppWalletsUnsupported from "./AppWalletsUnsupported";
const MNEMONIC_NA = "N/A";
export default function AppWalletImport() {
  const $ = _c(17);
  const [isMnemonic, setIsMnemonic] = useState(true);
  const {
    appWalletsSupported
  } = useAppWallets();
  if (!appWalletsSupported) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Container><AppWalletsUnsupported /></Container>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><Link className="font-smaller d-flex align-items-center gap-2 decoration-none" href="/tools/app-wallets"><FontAwesomeIcon icon={faCircleArrowLeft} height={16} />Back to App Wallets</Link></Col></Row>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Row className="pt-4"><Col><h1>Import App Wallet</h1></Col></Row>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isMnemonic ? "info" : "outline-info";
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsMnemonic(true);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <Col><Button variant={t2} onClick={t3} className="btn-block">Mnemonic</Button></Col>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !isMnemonic ? "info" : "outline-info";
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsMnemonic(false);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <Col><Button variant={t5} onClick={t6} className="btn-block">Private Key</Button></Col>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t7) {
    t8 = <Container className="pt-5">{t0}{t1}<Row className="pt-4">{t4}{t7}</Row></Container>;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isMnemonic) {
    t9 = isMnemonic ? <AppWalletImportMnemonic /> : <AppWalletImportPrivateKey />;
    $[12] = isMnemonic;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}
function AppWalletImportMnemonic() {
  const $ = _c(39);
  const inputRef = useRef(null);
  const {
    setToast
  } = useAuth();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Array(12).fill("");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [phrase, setPhrase] = useState(t0);
  const [isReadonly, setIsReadonly] = useState(false);
  const [currentFocus, setCurrentFocus] = useState(0);
  const [error, setError] = useState("");
  const [validatedWallet, setValidatedWallet] = useState();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setPhrase(Array(12).fill(""));
      setError("");
      setIsReadonly(false);
      setValidatedWallet(undefined);
      setCurrentFocus(0);
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const clear = t1;
  let t2;
  if ($[2] !== phrase) {
    t2 = () => {
      setIsReadonly(true);
      ;
      try {
        const wallet = ethers.Wallet.fromPhrase(phrase.join(" "));
        setValidatedWallet(wallet);
      } catch (t3) {
        const e = t3;
        setError(`Error: ${e.message}`);
      }
    };
    $[2] = phrase;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const validate = t2;
  let t3;
  if ($[4] !== phrase) {
    t3 = function isCompletePhrase() {
      return phrase.every(_temp);
    };
    $[4] = phrase;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const isCompletePhrase = t3;
  let t4;
  if ($[6] !== currentFocus || $[7] !== phrase || $[8] !== setToast) {
    let t5;
    if ($[10] !== currentFocus || $[11] !== setToast) {
      t5 = (w_0, i) => <Col xs={6} sm={4} md={3} className="pt-2 pb-2" key={getRandomObjectId()}><Container className={`${styles.phrase}`}><Row><Col className="d-flex gap-2"><span className="font-color-h font-lighter">{i + 1}</span><span><input autoFocus={i === currentFocus} type="text" placeholder={`word ${i + 1}`} value={w_0} className={styles.importWalletWordInput} onChange={e_0 => {
                  const newPhrase = e_0.target.value;
                  if (/^[a-z]*$/.test(newPhrase)) {
                    setPhrase(prev => {
                      const currentPhrase = [...prev];
                      currentPhrase[i] = newPhrase;
                      return currentPhrase;
                    });
                  } else {
                    setToast({
                      message: "Mnemonic word can only contain lowercase alphabet characters",
                      type: "error"
                    });
                  }
                }} onFocus={() => setCurrentFocus(i)} /></span></Col></Row></Container></Col>;
      $[10] = currentFocus;
      $[11] = setToast;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = phrase.map(t5);
    $[6] = currentFocus;
    $[7] = phrase;
    $[8] = setToast;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <Row>{t4}</Row>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== isCompletePhrase || $[16] !== phrase) {
    t6 = !phrase.some(_temp2) && !isCompletePhrase();
    $[15] = isCompletePhrase;
    $[16] = phrase;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t6) {
    t7 = <Button variant="warning" onClick={clear} className="font-bolder" disabled={t6}>Clear</Button>;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== isCompletePhrase || $[21] !== isReadonly) {
    t8 = !isCompletePhrase() || isReadonly;
    $[20] = isCompletePhrase;
    $[21] = isReadonly;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t8 || $[24] !== validate) {
    t9 = <Button variant="primary" disabled={t8} onClick={validate} className="font-bolder">Validate</Button>;
    $[23] = t8;
    $[24] = validate;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t7 || $[27] !== t9) {
    t10 = <Row className="pt-4"><Col className="d-flex align-items-center justify-content-between">{t7}{t9}</Col></Row>;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== error) {
    t11 = error && <ValidationError error={error} />;
    $[29] = error;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== phrase || $[32] !== validatedWallet) {
    t12 = validatedWallet && <ValidatedWallet wallet={validatedWallet} mnemonic={phrase.join(" ")} />;
    $[31] = phrase;
    $[32] = validatedWallet;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t5) {
    t13 = <Container className="pt-3 pb-5">{t5}{t10}{t11}{t12}</Container>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
    $[37] = t5;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
}
function _temp2(w_1) {
  return w_1;
}
function _temp(w) {
  return w;
}
function AppWalletImportPrivateKey() {
  const $ = _c(24);
  const inputRef = useRef(null);
  const [privateKey, setPrivateKey] = useState("");
  const [isReadonly, setIsReadonly] = useState(false);
  const [error, setError] = useState("");
  const [validatedWallet, setValidatedWallet] = useState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setPrivateKey("");
      setError("");
      setIsReadonly(false);
      setValidatedWallet(undefined);
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const clear = t0;
  let t1;
  if ($[1] !== privateKey) {
    t1 = () => {
      setIsReadonly(true);
      ;
      try {
        const wallet = new ethers.Wallet(privateKey);
        setValidatedWallet(wallet);
      } catch (t2) {
        const e = t2;
        setError(`Error: ${e.message}`);
      }
    };
    $[1] = privateKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const validate = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e_0 => setPrivateKey(e_0.target.value);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isReadonly || $[5] !== privateKey) {
    t3 = <Row><Col className="pt-2 pb-2"><Container className={`${styles.phrase}`}><Row><Col className="d-flex gap-2"><input ref={inputRef} autoFocus={true} disabled={isReadonly} type="text" placeholder="private key" value={privateKey} className={styles.importWalletWordInput} onChange={t2} /></Col></Row></Container></Col></Row>;
    $[4] = isReadonly;
    $[5] = privateKey;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !privateKey;
  let t5;
  if ($[7] !== t4) {
    t5 = <Button variant="warning" onClick={clear} className="font-bolder" disabled={t4}>Clear</Button>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !privateKey || isReadonly;
  let t7;
  if ($[9] !== t6 || $[10] !== validate) {
    t7 = <Button variant="primary" disabled={t6} onClick={validate} className="font-bolder">Validate</Button>;
    $[9] = t6;
    $[10] = validate;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <Row className="pt-4"><Col className="d-flex align-items-center justify-content-between">{t5}{t7}</Col></Row>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== error) {
    t9 = error && <ValidationError error={error} />;
    $[15] = error;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== validatedWallet) {
    t10 = validatedWallet && <ValidatedWallet wallet={validatedWallet} mnemonic={MNEMONIC_NA} />;
    $[17] = validatedWallet;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3 || $[21] !== t8 || $[22] !== t9) {
    t11 = <Container className="pt-3 pb-5">{t3}{t8}{t9}{t10}</Container>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}
function ValidationError(props) {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.error) {
    t0 = <Col xs={12}>{props.error}</Col>;
    $[0] = props.error;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Col xs={12}>- Clear the form and try again</Col>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Row className="pt-3">{t0}{t1}</Row>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function ValidatedWallet(props) {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Col xs={12} className="d-flex align-items-center gap-2"><FontAwesomeIcon icon={faCheckCircle} height={22} color="#00ff00" />Private Key is Valid!</Col>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.wallet.address) {
    t1 = <Col xs={12} className="pt-2">- Address: {props.wallet.address}</Col>;
    $[1] = props.wallet.address;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.mnemonic || $[4] !== props.wallet) {
    t2 = <Col xs={12} className="pt-3"><ImportWallet wallet={props.wallet} mnemonic={props.mnemonic} /></Col>;
    $[3] = props.mnemonic;
    $[4] = props.wallet;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <Row className="pt-4">{t0}{t1}{t2}</Row>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function ImportWallet(props) {
  const $ = _c(14);
  const router = useRouter();
  const [showImportModal, setShowImportModal] = useState(false);
  let t0;
  if ($[0] !== router) {
    t0 = isSuccess => {
      setShowImportModal(false);
      if (isSuccess) {
        router.push("/tools/app-wallets");
      }
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.mnemonic || $[3] !== props.wallet.address || $[4] !== props.wallet.privateKey) {
    t1 = {
      address: props.wallet.address,
      mnemonic: props.mnemonic,
      privateKey: props.wallet.privateKey
    };
    $[2] = props.mnemonic;
    $[3] = props.wallet.address;
    $[4] = props.wallet.privateKey;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== showImportModal || $[7] !== t0 || $[8] !== t1) {
    t2 = <CreateAppWalletModal show={showImportModal} onHide={t0} import={t1} />;
    $[6] = showImportModal;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setShowImportModal(true);
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button variant="primary" onClick={t3} className="d-flex align-items-center gap-2"><FontAwesomeIcon icon={faPlusCircle} height={16} /> Import Wallet</Button>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2) {
    t5 = <div className="d-flex gap-2">{t2}{t4}</div>;
    $[12] = t2;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}